<script>
import { layoutMethods } from "@/state/helpers";
import { menuItems } from "./horizontal-menu";
import { mapGetters } from "vuex";
import { abilityCheck } from "@/helpers/helper.js";

export default {
  data() {
    return {
      menuItems: menuItems,
    };
  },
  computed: {
    ...mapGetters('authfack', ['userdata']),
    currentPath() {
      return this.$route.path.replace(/\/$/, '') || '/';
    },
  },
  methods: {
    ...layoutMethods,
    normalizePath(link) {
      if (!link) return '';
      const path = link.split('?')[0].replace(/\/$/, '');
      return path || '/';
    },
    isLinkActive(link) {
      return this.normalizePath(link) === this.currentPath;
    },
    isParentActive(item) {
      if (!item.subItems || !item.subItems.length) {
        return this.isLinkActive(item.link);
      }
      return item.subItems.some(sub => this.checkRole(sub) && this.isLinkActive(sub.link));
    },
    resetDropdownPosition(dropdown) {
      if (!dropdown) return;
      dropdown.classList.remove('hnav__dropdown--align-right', 'hnav__dropdown--stack');
      dropdown.style.left = '';
      dropdown.style.right = '';
      dropdown.style.maxHeight = '';
    },

    positionDropdown(dropdown) {
      if (!dropdown || window.innerWidth < 992) return;

      this.resetDropdownPosition(dropdown);

      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const padding = 12;
          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;
          let rect = dropdown.getBoundingClientRect();

          if (!rect.width && !rect.height) return;

          if (rect.right > viewportWidth - padding) {
            dropdown.classList.add('hnav__dropdown--align-right');
            rect = dropdown.getBoundingClientRect();
          }

          if (rect.left < padding || rect.right > viewportWidth - padding) {
            dropdown.classList.add('hnav__dropdown--stack');
            rect = dropdown.getBoundingClientRect();
          }

          if (rect.bottom > viewportHeight - padding) {
            dropdown.classList.add('hnav__dropdown--stack');
            const maxHeight = Math.max(160, viewportHeight - rect.top - padding);
            dropdown.style.maxHeight = `${maxHeight}px`;
          }
        });
      });
    },

    onItemEnter(event) {
      if (window.innerWidth < 992) return;
      const dropdown = event.currentTarget.querySelector('.hnav__dropdown');
      if (dropdown) this.positionDropdown(dropdown);
    },

    onMenuClick(event) {
      event.preventDefault();
      const trigger = event.currentTarget;
      const navItem = trigger.closest('.nav-item');
      const dropdown = trigger.nextElementSibling;

      document.querySelectorAll('.hnav__item.show').forEach((el) => {
        if (el !== navItem) {
          el.classList.remove('show');
          const menu = el.querySelector('.dropdown-menu');
          if (menu) {
            menu.classList.remove('show');
            this.resetDropdownPosition(menu);
          }
        }
      });

      if (navItem && dropdown) {
        const willOpen = !dropdown.classList.contains('show');
        navItem.classList.toggle('show', willOpen);
        dropdown.classList.toggle('show', willOpen);
        if (willOpen) {
          this.positionDropdown(dropdown);
        } else {
          this.resetDropdownPosition(dropdown);
        }
      }
      return false;
    },
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    menuIcon(icon) {
      if (!icon) return '';
      if (icon.indexOf(' ') !== -1) return icon;
      if (icon.indexOf('bx-') === 0) return `bx ${icon}`;
      return `bx bx-${icon}`;
    },
    subitemClass(subitem) {
      return {
        'hnav__subitem--border-top': subitem.border === 'top',
        'hnav__subitem--border-bottom': subitem.border === 'bottom',
        'hnav__subitem--active': this.isLinkActive(subitem.link),
      };
    },
    checkRole(role) {
      const userdata = JSON.parse(localStorage.getItem('userdata'))
      if (abilityCheck(role.key)) {
        return true
      }
      if (role.auth) {
        if (role.auth.indexOf('|')) {
          return role.auth.split('|').includes(userdata.role_name)
        }
      }
      return true;
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
  },
};
</script>

<template>
  <div class="topnav hnav">
    <div class="container-full">
      <nav class="navbar navbar-light navbar-expand-lg topnav-menu hnav__bar">
        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul class="navbar-nav hnav__list">
            <template v-for="(item, index) of menuItems">
              <li
                class="nav-item dropdown hnav__item"
                :class="{ 'hnav__item--active': isParentActive(item) }"
                :key="index"
                v-if="checkRole(item)"
                @mouseenter="onItemEnter($event)"
              >
                <router-link
                  class="nav-link hnav__link"
                  :class="{ 'hnav__link--active': isParentActive(item) }"
                  v-if="!item.subItems"
                  :to="item.link"
                  :exact="item.link === '/'"
                  role="button"
                >
                  <i v-if="item.icon" :class="[menuIcon(item.icon), 'hnav__link-icon']"></i>
                  <span class="hnav__link-text">{{ $t(item.label) }}</span>
                </router-link>

                <a
                  v-if="item.subItems"
                  class="nav-link hnav__link"
                  :class="{ 'hnav__link--active': isParentActive(item) }"
                  @click="onMenuClick($event)"
                  role="button"
                  href="#"
                >
                  <i v-if="item.icon" :class="[menuIcon(item.icon), 'hnav__link-icon']"></i>
                  <span class="hnav__link-text">{{ $t(item.label) }}</span>
                  <i class="bx bx-chevron-down hnav__chevron"></i>
                </a>

                <div
                  class="dropdown-menu hnav__dropdown"
                  aria-labelledby="topnav-dashboard"
                  v-if="hasItems(item)"
                >
                  <template v-for="(subitem, subIndex) of item.subItems">
                    <router-link
                      class="col dropdown-item side-nav-link-ref hnav__subitem"
                      :class="subitemClass(subitem)"
                      :key="subIndex"
                      v-if="checkRole(subitem)"
                      :to="subitem.link"
                      exact
                    >
                      <span class="hnav__subitem-text">{{ $t(subitem.label) }}</span>
                      <i class="bx bx-chevron-right hnav__subitem-arrow"></i>
                    </router-link>
                  </template>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<style scoped>
.hnav {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.04);
}

.hnav >>> .navbar-nav {
  gap: 4px;
  padding: 6px 0;
}

.hnav >>> .hnav__item {
  position: relative;
}

.hnav >>> .hnav__link {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  padding: 9px 14px !important;
  border-radius: 10px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #475569 !important;
  border: 1px solid transparent;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}

.hnav >>> .hnav__link-icon {
  font-size: 17px;
  line-height: 1;
  color: #64748b;
  transition: color 0.15s ease;
}

.hnav >>> .hnav__link-text {
  line-height: 1.2;
}

.hnav >>> .hnav__chevron {
  font-size: 16px;
  color: #94a3b8;
  margin-left: 2px;
  transition: transform 0.2s ease, color 0.15s ease;
}

.hnav >>> .hnav__link:hover,
.hnav >>> .hnav__item.show > .hnav__link {
  background: #eff6ff !important;
  color: #2563eb !important;
  border-color: #bfdbfe;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.08);
}

.hnav >>> .hnav__link:hover .hnav__link-icon,
.hnav >>> .hnav__item.show > .hnav__link .hnav__link-icon {
  color: #2563eb;
}

.hnav >>> .hnav__item.show > .hnav__link .hnav__chevron {
  transform: rotate(180deg);
  color: #2563eb;
}

.hnav >>> .hnav__link.hnav__link--active,
.hnav >>> .hnav__link.router-link-exact-active {
  background: linear-gradient(135deg, #2563eb, #1d4ed8) !important;
  color: #fff !important;
  border-color: transparent;
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.28);
}

.hnav >>> .hnav__link.hnav__link--active .hnav__link-icon,
.hnav >>> .hnav__link.router-link-exact-active .hnav__link-icon,
.hnav >>> .hnav__link.hnav__link--active .hnav__chevron,
.hnav >>> .hnav__link.router-link-exact-active .hnav__chevron {
  color: #fff;
}

.hnav >>> .hnav__dropdown {
  display: none;
  border: 1px solid #e2e8f0 !important;
  border-radius: 14px !important;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12) !important;
  padding: 8px !important;
  margin-top: 8px !important;
  background: #fff !important;
  min-width: 240px;
  width: max-content;
  max-width: calc(100vw - 24px);
  grid-template-rows: repeat(6, auto);
  grid-auto-flow: column;
  gap: 4px 12px;
  transform-origin: top center;
  left: 0;
  right: auto;
}

.hnav >>> .hnav__dropdown--align-right {
  left: auto !important;
  right: 0 !important;
  transform-origin: top right;
}

.hnav >>> .hnav__dropdown--stack {
  grid-auto-flow: row !important;
  grid-template-rows: unset !important;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.hnav >>> .hnav__item.show .hnav__dropdown,
.hnav >>> .hnav__dropdown.show {
  display: grid !important;
  animation: hnav-dropdown-in 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.hnav >>> .hnav__item:hover > .hnav__dropdown {
  display: grid !important;
  animation: hnav-dropdown-in 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.hnav >>> .hnav__dropdown::before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  width: 100%;
  height: 12px;
  background: transparent;
}

.hnav >>> .hnav__subitem {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px !important;
  border-radius: 10px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #334155 !important;
  background: transparent !important;
  transition: background 0.15s ease, color 0.15s ease, padding 0.15s ease;
  white-space: nowrap;
}

.hnav >>> .hnav__subitem--border-top {
  margin-top: 6px;
  padding-top: 14px !important;
  border-top: 1px dashed #e2e8f0;
}

.hnav >>> .hnav__subitem--border-bottom {
  margin-bottom: 6px;
  padding-bottom: 14px !important;
  border-bottom: 1px dashed #e2e8f0;
}

.hnav >>> .hnav__subitem-text {
  flex: 1;
  min-width: 0;
}

.hnav >>> .hnav__subitem-arrow {
  font-size: 16px;
  color: #2563eb;
  opacity: 0;
  transform: translateX(-6px);
  transition: opacity 0.15s ease, transform 0.15s ease;
  flex-shrink: 0;
}

.hnav >>> .hnav__subitem:hover,
.hnav >>> .hnav__subitem:focus {
  background: #f1f5f9 !important;
  color: #2563eb !important;
  padding-left: 16px !important;
}

.hnav >>> .hnav__subitem:hover .hnav__subitem-arrow,
.hnav >>> .hnav__subitem:focus .hnav__subitem-arrow {
  opacity: 1;
  transform: translateX(0);
}

.hnav >>> .hnav__subitem.hnav__subitem--active,
.hnav >>> .hnav__subitem.router-link-exact-active {
  background: #eff6ff !important;
  color: #1d4ed8 !important;
  font-weight: 600 !important;
}

.hnav >>> .hnav__subitem.hnav__subitem--active .hnav__subitem-arrow,
.hnav >>> .hnav__subitem.router-link-exact-active .hnav__subitem-arrow {
  opacity: 1;
  transform: translateX(0);
}

.hnav >>> .hnav__item--active > .hnav__link:not(.hnav__link--active) {
  color: #2563eb !important;
}

@keyframes hnav-dropdown-in {
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 991.98px) {
  .hnav >>> .navbar-nav {
    padding: 10px 0;
    gap: 2px;
  }

  .hnav >>> .hnav__link {
    width: 100%;
    justify-content: flex-start;
  }

  .hnav >>> .hnav__dropdown {
    position: static !important;
    float: none;
    box-shadow: none !important;
    border: none !important;
    border-left: 2px solid #dbeafe !important;
    border-radius: 0 10px 10px 0 !important;
    margin: 4px 0 8px 12px !important;
    padding: 4px 8px !important;
    width: auto !important;
    min-width: 0;
    grid-auto-flow: row;
    grid-template-rows: unset;
  }

  .hnav >>> .hnav__subitem {
    white-space: normal;
  }
}
</style>
